<ng-container *transloco="let t">
  <div>
    <a
      class="link __complex __gray"
      target="_blank"
      [href]="terms"
      >{{ t('common.terms-of-use') }}</a
    >
  </div>
  <div>
    <a
      class="link __complex __gray"
      target="_blank"
      [href]="privacyPolicy"
      >{{ t('common.privacy-policy') }}</a
    >
  </div>
  <div>
    <a
      class="link __complex __gray"
      target="_blank"
      [href]="imprint"
      >{{ t('common.imprint') }}</a
    >
  </div>
</ng-container>
